import React, { Component } from "react";

import queryString from "query-string";
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import DynamicFormToFilter from "../../../components/forms/DynamicFormToFilter";
import DefaultMultipleSelect from "../../../components/DefaultMultipleSelect/DefaultMultipleSelect";
import CustomSplineArea from "../../../components/Charts/splineArea";
import { getCurrentDay, getSelectedMonthAgo } from "../../../helpers/utils";
import { getApplications } from "../../../store/apps/actions";
import {
  getQualityTopManagementMediaBuyerSpend,
  getQualityTopManagementMediaBuyerStats,
  getReportCampaignCountBy,
  getTopManagementAppProfit,
  getTopManagementClientSpend,
  getTopManagementMediaBuyerProfit,
  getTopManagementOfferProfit,
  getTopManagementProfit,
  setTopManagementDate,
} from "../../../store/reporting/actions";
import { getClientsList } from "../../../store/clients/actions";
import { getMediaBuyerDataForAdd } from "../../../store/mediabuyers/mediabuyerbudget/actions";
import { getOffers } from "../../../store/offers/actions";
import AppReports from "./common/AppReports/AppReports";
import MediaBuyerReports from "./common/MediaBuyerReports/MediaBuyerReports";
import OfferReports from "./common/OfferReports/OfferReports";
import ClientReports from "./common/ClientReports/ClientReports";
import ReportingBreadcrumbTitle from "../ReportingBreadcrumbTitle";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class TopManagementReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: {
        from: null,
        to: null,
      },
      mediaBuyers: null,
      offerTypes: null,
      apps: null,
      clients: null,
      reportCountBy: ["app", "client", "offer", "mediabuyer"],
    };
  }

  componentDidMount() {
    const data = this.props.profit;
    const parsedSearch = queryString.parse(this.props.history.location.search);

    if (this.props.topManagementDate === null) {
      data.start_date = parsedSearch.start_date || getSelectedMonthAgo(2);
      data.end_date = parsedSearch.end_date || getCurrentDay();

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: data.start_date,
          end_date: data.end_date,
        })
      );

      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
      this.props.setTopManagementDate(data);

      this.state.reportCountBy.map(i => {
        this.props.getReportCampaignCountBy(data, i);
      });
      this.props.getTopManagementProfit(data);
      this.props.getTopManagementOfferProfit(data);
      this.props.getTopManagementMediaBuyerProfit(data);
      this.props.getQualityTopManagementMediaBuyerSpend(data);
      this.props.getQualityTopManagementMediaBuyerStats(data);
      this.props.getTopManagementAppProfit(data);
      this.props.getTopManagementClientSpend(data);
    } else {
      let topManagementDate = this.props.topManagementDate;

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: topManagementDate.start_date,
          end_date: topManagementDate.end_date,
        })
      );

      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);

      this.state.reportCountBy.map(i => {
        this.props.getReportCampaignCountBy(topManagementDate, i);
      });
      this.props.getTopManagementProfit(topManagementDate);
      this.props.getTopManagementOfferProfit(topManagementDate);
      this.props.getTopManagementMediaBuyerProfit(topManagementDate);
      this.props.getQualityTopManagementMediaBuyerSpend(topManagementDate);
      this.props.getQualityTopManagementMediaBuyerStats(topManagementDate);
      this.props.getTopManagementAppProfit(topManagementDate);
      this.props.getTopManagementClientSpend(topManagementDate);
    }

    this.props.getApplications(this.props.apps);
    this.props.getClientsList(this.props.clients);
    this.props.getMediaBuyerDataForAdd();
    this.props.getOffers({
      ...this.props.offers,
      is_main: false,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  onFiltersChange = (type, filter) => {
    const parsedSearch = queryString.parse(this.props.history.location.search);
    const data = this.props.topManagementDate;
    data.start_date = filter.start_date;
    data.end_date = filter.end_date;

    let formQueryString = queryString.stringify(
      Object.assign(parsedSearch, {
        start_date: data.start_date,
        end_date: data.end_date,
      })
    );

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);

    this.state.reportCountBy.map(i => {
      this.props.getReportCampaignCountBy(data, i);
    });

    this.props.getMediaBuyerDataForAdd();
    this.props.getTopManagementProfit(data);
    this.props.getTopManagementOfferProfit(data);
    this.props.getTopManagementMediaBuyerProfit(data);
    this.props.getQualityTopManagementMediaBuyerStats(data);
    this.props.getTopManagementClientSpend(data);
    this.props.getTopManagementAppProfit(data);
    this.props.getQualityTopManagementMediaBuyerSpend(data);
  };

  handleSelect = (type, data, _) => {
    const filteredData = [];
    let formQueryString = "";
    let topManagementDate = "";
    const prevHistory = queryString.parse(this.props.history.location.search);

    data.map(i => filteredData.push(i.value));

    switch (type) {
      case "app":
        topManagementDate = this.props.topManagementDate;
        topManagementDate.tracker_app_id = filteredData.join();
        this.props.getReportCampaignCountBy(topManagementDate, "app");
        formQueryString = queryString.stringify(
          Object.assign(prevHistory, {
            start_date: topManagementDate.start_date,
            end_date: topManagementDate.end_date,
            tracker_app_id: filteredData,
          })
        );
        this.props.getTopManagementAppProfit(topManagementDate);
        break;
      case "client":
        topManagementDate = this.props.topManagementDate;
        topManagementDate.client_id = filteredData.join();
        this.props.getReportCampaignCountBy(topManagementDate, "client");
        formQueryString = queryString.stringify(
          Object.assign(prevHistory, {
            start_date: topManagementDate.start_date,
            end_date: topManagementDate.end_date,
            client_id: filteredData,
          })
        );
        this.props.getTopManagementClientSpend(topManagementDate);
        break;
      case "offer":
        topManagementDate = this.props.topManagementDate;
        topManagementDate.offer_id = filteredData.join();
        this.props.getReportCampaignCountBy(topManagementDate, "offer");
        formQueryString = queryString.stringify(
          Object.assign(prevHistory, {
            start_date: topManagementDate.start_date,
            end_date: topManagementDate.end_date,
            offer_id: filteredData,
          })
        );
        this.props.getTopManagementOfferProfit(topManagementDate);
        break;
      case "mediabuyer":
        topManagementDate = this.props.topManagementDate;
        topManagementDate.mediabuyer = filteredData.join();
        this.props.getReportCampaignCountBy(topManagementDate, "mediabuyer");
        formQueryString = queryString.stringify(
          Object.assign(prevHistory, {
            start_date: topManagementDate.start_date,
            end_date: topManagementDate.end_date,
            mediabuyer: filteredData,
          })
        );
        this.props.getTopManagementMediaBuyerProfit(topManagementDate);
        this.props.getQualityTopManagementMediaBuyerStats(topManagementDate);
        this.props.getQualityTopManagementMediaBuyerSpend(topManagementDate);
        break;
    }

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
  };

  render() {
    return (
      <>
        <React.Fragment>
          <div className="page-content">
          <ModifiedMetaTags title="Top management reports | Mobihunter" />

            <Container fluid>
              <Breadcrumbs
                title="Dashboard"
                breadcrumbItem="Top management report"
                link="/top-management-report"
                customBreadcrumbItem={
                  <ReportingBreadcrumbTitle title="Top management report" />
                }
              />

              <DynamicFormToFilter
                onFiltersChange={this.onFiltersChange}
                selectedDate={
                  Object.keys(
                    queryString.parse(this.props.history.location.search)
                  ).length === 0
                    ? this.props.topManagementDate
                    : queryString.parse(this.props.history.location.search)
                }
              />

              <Card>
                <CardBody>
                  <Row className="justify-content-between align-middle">
                    <Col xs={6}>
                      <h5 className="mb-2">Common profit by each day</h5>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <Row className="justify-content-between"></Row>
                      <CustomSplineArea data={this.props.profit} currency="$" />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Row className="justify-content-between align-middle">
                    <Col xs={6}>
                      <h5 className="mb-2">Reporting by client app</h5>
                      <p className="mb-3">
                        Profits by each day, media buyer, each offer, app.
                      </p>
                    </Col>
                    <Col xs={6} className="align-content-end mt-1">
                      <Form className="row align-items-center float-end">
                        <div className="col-sm-auto">
                          <span>Filter by: </span>
                        </div>
                        <div className="col-sm-auto">
                          <DefaultMultipleSelect
                            options={this.props.apps.results.map(
                              ({ app_id, name, checked }) => ({
                                key: app_id,
                                text: name,
                                checked,
                              })
                            )}
                            onChange={e => this.handleSelect("app", e)}
                            filtered_params={queryString.parse(
                              this.props.history.location.search
                            )}
                            filtered_by="tracker_app_id"
                            plug="Select app.."
                            search
                          />
                        </div>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <AppReports
                        countByApp={this.props.countByApp}
                        profitPyEachDay={this.props.profit}
                        mediaBuyerProfit={this.props.mediaBuyerProfit}
                        offerProfit={this.props.offerProfit}
                        appProfit={this.props.appProfit}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Row className="justify-content-between align-middle">
                    <Col xs={6}>
                      <h5 className="mb-2 mt-2">Reporting by media buyer</h5>
                      <p className="mb-3">
                        Statistics, spend and other metrics by media buyer.
                      </p>
                    </Col>
                    <Col xs={6} className="align-content-end mt-1">
                      <Form className="row align-items-center float-end">
                        <div className="col-sm-auto">
                          <span>Filter by: </span>
                        </div>
                        <div className="col-sm-auto">
                          <DefaultMultipleSelect
                            options={
                              this.props.dataForAddBudget !== null
                                ? this.props.dataForAddBudget.mediaBuyers.map(
                                    ({ id, number, checked }) => ({
                                      key: id,
                                      text: number,
                                      checked,
                                    })
                                  )
                                : []
                            }
                            filtered_by="mediabuyer"
                            filtered_params={queryString.parse(
                              this.props.history.location.search
                            )}
                            onChange={e => this.handleSelect("mediabuyer", e)}
                            plug="Select media buyer.."
                            search
                          />
                        </div>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <MediaBuyerReports
                        countByMediaBuyer={this.props.countByMediaBuyer}
                        mediaBuyerStats={this.props.mediaBuyerStats}
                        mediaBuyerSpend={this.props.mediaBuyerSpend}
                        mediaBuyerProfit={this.props.mediaBuyerProfit}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Row className="justify-content-between align-middle">
                    <Col xs={6}>
                      <h5 className="mb-2 mt-2">Reporting by client</h5>
                      <p className="mb-3">
                        Statistics, spend and other metrics by media buyer.
                      </p>
                    </Col>
                    <Col xs={6} className="align-content-end mt-1">
                      <Form className="row align-items-center float-end">
                        <div className="col-sm-auto">
                          <span>Filter by: </span>
                        </div>
                        <div className="col-sm-auto">
                          <DefaultMultipleSelect
                            options={this.props.clients.results.map(
                              ({ id, real_name, checked }) => ({
                                key: id,
                                text: real_name,
                                checked,
                              })
                            )}
                            filtered_by="client_id"
                            filtered_params={queryString.parse(
                              this.props.history.location.search
                            )}
                            onChange={e => this.handleSelect("client", e)}
                            plug="Select client.."
                            search
                          />
                        </div>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <ClientReports
                        countByClient={this.props.countByClient}
                        clientSpend={this.props.clientSpend}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Row className="justify-content-between align-middle">
                    <Col xs={6}>
                      <h5 className="mb-2 mt-2">Reporting by offer</h5>
                      <p className="mb-3">
                        Statistics, spend and other metrics by media buyer.
                      </p>
                    </Col>
                    <Col xs={6} className="align-content-end mt-2">
                      <Form className="row align-items-center float-end">
                        <div className="col-sm-auto">
                          <span>Filter by: </span>
                        </div>
                        <div className="col-sm-auto">
                          <DefaultMultipleSelect
                            options={
                              this.props.offers.results !== undefined
                                ? this.props.offers.results.map(
                                    ({ id, name, checked }) => ({
                                      key: id,
                                      text: name,
                                      checked,
                                    })
                                  )
                                : []
                            }
                            filtered_by="offer_id"
                            filtered_params={queryString.parse(
                              this.props.history.location.search
                            )}
                            onChange={e => this.handleSelect("offer", e)}
                            plug="Select offer.."
                            search
                          />
                        </div>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <OfferReports
                        countByOffer={this.props.countByOffer}
                        offerProfit={this.props.offerProfit}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </div>
        </React.Fragment>
      </>
    );
  }
}

TopManagementReports.propTypes = {
  history: PropTypes.any,
  profit: PropTypes.any,
  mediaBuyerProfit: PropTypes.any,
  offerProfit: PropTypes.any,
  dataForAddBudget: PropTypes.object,
  offers: PropTypes.any.isRequired,
  mediaBuyerCampQty: PropTypes.any,
  mediaBuyerStats: PropTypes.any,
  mediaBuyerSpend: PropTypes.any,
  appProfit: PropTypes.any,
  countByApp: PropTypes.any,
  countByClient: PropTypes.any,
  countByOffer: PropTypes.any,
  countByMediaBuyer: PropTypes.any,
  clientSpend: PropTypes.any,
  apps: PropTypes.any,
  clients: PropTypes.any,
  topManagementDate: PropTypes.any,
  getTopManagementProfit: PropTypes.func.isRequired,
  getTopManagementOfferProfit: PropTypes.func.isRequired,
  getTopManagementMediaBuyerProfit: PropTypes.func.isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  getOffers: PropTypes.func.isRequired,
  getQualityTopManagementMediaBuyerSpend: PropTypes.func.isRequired,
  getQualityTopManagementMediaBuyerStats: PropTypes.func.isRequired,
  getTopManagementAppProfit: PropTypes.func.isRequired,
  getTopManagementClientSpend: PropTypes.func.isRequired,
  getReportCampaignCountBy: PropTypes.func.isRequired,
  getApplications: PropTypes.func.isRequired,
  getClientsList: PropTypes.func.isRequired,
  setTopManagementDate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  profit: state.Reporting.profit,
  mediaBuyerProfit: state.Reporting.mediaBuyerProfit,
  offerProfit: state.Reporting.offerProfit,
  appProfit: state.Reporting.appProfit,
  mediaBuyerStats: state.Reporting.mediaBuyerStats,
  mediaBuyerSpend: state.Reporting.mediaBuyerSpend,
  countByApp: state.Reporting.countByApp,
  countByClient: state.Reporting.countByClient,
  countByOffer: state.Reporting.countByOffer,
  countByMediaBuyer: state.Reporting.countByMediaBuyer,
  clientSpend: state.Reporting.clientSpend,
  offers: state.Offers.offers,
  apps: state.Apps.data,
  clients: state.Clients.data,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
  topManagementDate: state.Reporting.topManagementDate,
});

export default connect(mapStateToProps, {
  getTopManagementProfit,
  getTopManagementOfferProfit,
  getTopManagementMediaBuyerProfit,
  getMediaBuyerDataForAdd,
  getOffers,
  getQualityTopManagementMediaBuyerSpend,
  getQualityTopManagementMediaBuyerStats,
  getTopManagementAppProfit,
  getTopManagementClientSpend,
  getReportCampaignCountBy,
  getApplications,
  getClientsList,
  setTopManagementDate,
})(TopManagementReports);
